/**
 * Formats a CEP (Brazilian ZIP code) string into the XXXXX-XXX format.
 * @param cep The raw CEP string.
 * @returns The formatted CEP string or "-" if invalid/empty.
 */
export const formatCEP = (cep: string | undefined | null): string => {
  if (!cep) return "-";
  const cleaned = cep.replace(/\D/g, "");
  if (cleaned.length !== 8) return cleaned; // Return as is if it doesn't look like a full CEP
  return cleaned.replace(/^(\d{5})(\d{3})$/, "$1-$2");
};
